import React from 'react'
import PropTypes from 'prop-types'
import getUrlVoucherCode from '../../utils/getUrlVoucherCode'
import { setAffiliateCookiesFromUrl } from '../../utils/affiliates'

class App extends React.Component {
  componentDidMount() {
    const { voucherCode, setVoucherCode, plans, getPlans } = this.props

    const urlVoucher = getUrlVoucherCode(window.location.search)
    if (urlVoucher && urlVoucher !== voucherCode) {
      setVoucherCode(urlVoucher)
    }

    setAffiliateCookiesFromUrl(window.location.search)

    if (plans.plans.length === 0) {
      getPlans()
    }
  }

  render() {
    const { children } = this.props

    return <React.Fragment>{children}</React.Fragment>
  }
}

App.propTypes = {
  voucherCode: PropTypes.string,
  setVoucherCode: PropTypes.func.isRequired,
  children: PropTypes.node,
  plans: PropTypes.object,
  getPlans: PropTypes.func,
}

export default App
